import React from 'react';
import Header from '../../Universal/Header';
import Footer from '../../Universal/Footer';
import './Policies.css';

const RefundPolicy = () => {
    return (
        <div className="policy-page-header policy-page-wrapper">
            <Header />

            <div className="policy-hero">
                <div className="policy-hero-content">
                    <h1 className="policy-title">Refund Policy</h1>
                    
                </div>
            </div>

            <section className="policy-container">
                <div className="policy-content-wrapper">
                    <div className="policy-main-text">
                        <h3>Refund Guidelines</h3>
                        <ol>
                            <li>Membership fees once paid are generally non-refundable. However, in exceptional cases, a refund may be considered only upon approval of the Executive Committee of the B.E. College Ex-Students’ Club.</li>
                            <li>In case of duplicate or excess payments made due to technical errors, refund requests may be considered after verification.</li>
                            <li>Approved refunds will be processed to the original mode of payment within 7–10 working days.</li>
                            <li>Any request for refund must be submitted via email to the Club’s official contact email within a reasonable time period.</li>
                        </ol>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default RefundPolicy;
